import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ExpenseReportDocument from '../components/expense-report/ExpenseReportDocument';
import ExpenseReportToolbar from '../components/expense-report/ExpenseReportToolbar';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ExpenseReportPreview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const printRef = useRef();

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const response = await axios.get(`${API}/expense-reports/${id}`);
        setReport(response.data);
      } catch (error) {
        console.error('Failed to fetch expense report:', error);
        toast.error('Failed to load expense report');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchReport();
    }
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate('/expense-reports');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="flex items-center gap-3 text-slate-600">
          <Loader2 className="w-6 h-6 animate-spin" />
          <span>Loading expense report...</span>
        </div>
      </div>
    );
  }

  if (!report) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="text-center">
          <p className="text-slate-600 mb-4">Expense report not found</p>
          <button 
            onClick={handleBack}
            className="text-amber-600 hover:text-amber-700 font-medium"
          >
            Back to Expense Reports
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 print:bg-white">
      <ExpenseReportToolbar 
        onPrint={handlePrint}
        onBack={handleBack}
      />
      <div className="py-10 px-4 flex justify-center print:p-0 print:block" id="print-wrapper">
        <ExpenseReportDocument 
          report={report}
          printRef={printRef} 
        />
      </div>
    </div>
  );
}
